<template>


	<section class="learning_test">
		<div class="test_start">
			<h3>테스트는 총 {{ tstCount }}문항 입니다.</h3>
			<p>'테스트 시작' 버튼을 누르면 테스트가 시작됩니다. 테스트 도중에는 중단할 수 없습니다.</p>
			<div class="test_button">
				<button type="button" class="btn btn-lg btn-point" @click="tstStart">테스트 시작</button>
			</div>
		</div>
	</section>

</template>

<script>
export default {
	name: "ansTstStart",
	props: [
		"tstCount"
	],
	methods: {

		tstStart: function () {
			this.$emit("tstStart");
		}

	}
}
</script>

<style scoped>

</style>